<template>
    <section class="dashboard-infirmier main-section">
        <div class="body-header mb-4"><h1 class="p-title">Tableau de bord</h1><h2 class="p-subtitle text-grey">Bienvenue {{ user.name }}</h2></div>
        <ActiviteMedecin :mode_infirmier="true" />
        <ConsultationsMedecin :mode_infirmier="true" :mode_constantes="true" @constantes="ouvrir_constantes" />
        <!-- Poste de soins avec unités et transferts à accueillir, en une seule carte (04/10/2026). -->
        <PosteSoinsUnites />
        <SallePrelevement />
        <ConsultationsMedecin :mode_infirmier="true" />
        <ConstantesInfirmier v-model="constantes_ouvertes" :consultation="consultation" />
    </section>
</template>
<script>
import ActiviteMedecin from '../dashboard-medecin/activite-medecin'
import ConsultationsMedecin from '../dashboard-medecin/consultations-medecin'
import SallePrelevement from '../salle-prelevement'
import ConstantesInfirmier from './constantes-infirmier'
import PosteSoinsUnites from './poste-soins-unites.vue'

export default {
    name: 'dashboard-infirmier',
    components: { ActiviteMedecin, PosteSoinsUnites, ConsultationsMedecin, SallePrelevement, ConstantesInfirmier },
    data() { return { constantes_ouvertes: false, consultation: {} } },
    computed: { user() { return this.$store.getters.authInfo || {} } },
    methods: { ouvrir_constantes(item) { this.consultation = item; this.constantes_ouvertes = true } }
}
</script>
<style src="./dashboard-infirmier.scss" scoped lang="scss"></style>

